import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuGraphics } from '../Header/MenuGraphics';
import GradientWrapper from '../GradientBox/GradientWrapper';
const MenuButton = ({ onClick }) => {
    return (_jsxs("div", { className: "header-menu-button", onClick: onClick, children: [_jsx("div", { className: "header-menu-background", children: _jsx(GradientWrapper, { active: true, mask: "radial-gradient(circle, rgb(0, 0, 0) 70%, rgba(0, 0, 0, 0) 70%)" }) }), _jsx(MenuGraphics, {})] }));
};
export default MenuButton;
